import { Skeleton } from '@chakra-ui/react'
import React, { useContext } from 'react'
import './about.css'
import { Context } from './context/Context.js'

function About() {

    const {about, isAboutLoading} = useContext(Context)
    const {aboutTitle, aboutContent, aboutImage} = about


  return ( 
        <Skeleton isLoaded={isAboutLoading}>
            <section id="about">
               
                <div className='flex flex-col imageWrapper'>
                    <img src={aboutImage} alt={aboutTitle}/>
                </div>
                
                <div className='flex flex-col contentWrapper'>
                    <h2 className='title'>{aboutTitle}</h2>
                    <p className='content'> {aboutContent}</p>
                </div>


            </section>
        </Skeleton>
  )
}

export default About